import { Component } from '@angular/core';

@Component({
  selector: 'tt-404',
  templateUrl: './404.component.html',
  styleUrls: ['./404.component.css']
})
export class PageNotFoundComponent {
}
